<template>
  <div>
    <form-section>
      <template #form-header>
        <form-section-header>
          <!-- prettier-ignore -->
          <template #title>Toileting</template>
          <template #info>
            <div class="hidden lg:block">
              <p>Please select as appropriate</p>
            </div>
          </template>
        </form-section-header>
        <info-warning>
          <template #text>
            <div class="flex justify-center text-xs md:text-base">
              <span>Please provide nappies or pads if your child uses them</span>
            </div>
          </template>
        </info-warning>
      </template>

      <template #form-body>
        <div id="toileting" class="flex flex-col flex-wrap md:flex-row px-2 lg:px-0 md:mb-4">
          <!-- Easter 2026 - added due to increased numbers of male staff -->
          <div
            class="h-fit w-2/3 mb-8 px-3 pt-2 border-4 border-red-400 bg-white mt-6 flex flex-col rounded-md lg:rounded-lg lg:shadow-xl"
          >
            <fieldset>
              <legend class="text-sm/6 font-semibold text-gray-900">Please read carefully (new for 2026)</legend>
              <p class="py-2 text-gray-800 space-y-0 gap-y-1 flex flex-col">
                <span
                  >As part of our duty of care, some of our club users may require assistance with personal care during
                  sessions.</span
                >
                <span
                  >We would like to inform you that both male and female staff members are part of our team and may be
                  involved in providing personal care support when required. All staff members are appropriately
                  trained, experienced, and adhere strictly to safeguarding, dignity, and privacy policies.</span
                >
                <span>If you would like to discuss this further, please do not hesitate to contact us.</span>
              </p>
              <div class="mt-4 px-6">
                <div v-for="(opt, idx) in assistance" :key="idx" class="relative flex items-start pt-3.5 pb-4">
                  <div class="min-w-0 flex-1 text-sm/6">
                    <label :for="`account-${opt.id}`" class="font-medium text-gray-900">{{ opt.label }}</label>
                    <p :id="`account-${opt.id}-description`" class="text-gray-500">{{ opt.description }}</p>
                  </div>
                  <div class="ml-3 flex h-6 items-center mr-12">
                    <input
                      :id="`assistance-${opt.id}`"
                      :aria-describedby="`assistance-${opt.id}-description`"
                      name="assistance"
                      type="radio"
                      :checked="opt.value === true"
                      class="relative size-8 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-black checked:bg-black focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                      @input="selectAssistance"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="flex flex-wrap">
            <div v-for="(opt, idx) in options" :key="opt.label">
              <form-select-button
                active
                classes="mr-4 mb-2"
                :immediate="options[idx].selected"
                :title="opt.label"
                :name="opt.id"
                pill
                @selected="selectToileting(idx)"
              ></form-select-button>
            </div>
          </div>

          <form-text-input
            :area="true"
            name="toileting.special_equipment"
            title="Is there a need for a specific routine or special equipment?"
            placeholder="Please describe"
          ></form-text-input>

          <form-text-input
            :area="true"
            name="toileting.extra_info"
            title="Anything else you feel we should be aware of?"
            placeholder="Please give details"
          ></form-text-input>
        </div>
      </template>
    </form-section>
  </div>
</template>

<script>
import FormSelectButton from '@/components/form-select-button.vue';
import { store } from '@/store.js';

export default {
  components: {
    FormSelectButton,
  },

  data() {
    return {
      assistance: [
        { id: 'yes', value: false, label: 'I agree', description: 'No further action required' },
        {
          id: 'no',
          value: false,
          label: 'I do not agree',
          description: 'Club Management will contact you to discuss options',
        },
      ],
      options: [
        {
          id: 'toileting.options_1',
          label: 'Fully independent',
          selected: false,
        },
        {
          id: 'toileting.options_2',
          label: 'Wears pads, full assistance required',
          selected: false,
        },
        {
          id: 'toileting.options_3',
          label: 'Requires hoisting',
          selected: false,
        },
        {
          id: 'toileting.options_4',
          label: 'Requires a bed for changing',
          selected: false,
        },
        {
          id: 'toileting.options_5',
          label: 'Some physical support with wiping, dressing etc.',
          selected: false,
        },
        {
          id: 'toileting.options_6',
          label: 'Verbal prompts only (i.e. to wash hands)',
          selected: false,
        },
        {
          id: 'toileting.options_7',
          label: 'Toilet trained with occassional accidents',
          selected: false,
        },
      ],
    };
  },

  created() {
    // Inital selected state comes from the data source
    this.options.forEach(o => (o.selected = store.booking.find(o.id) || false));

    // toileting consent radio group...
    const assistance = store.booking.find('toileting.consent');
    // user may not yet have chosen so don't default anything for them...
    if (assistance !== undefined) {
      // booking.find converts yes/no to true/false but in this case it needs to be the string!
      const id = assistance ? 'yes' : 'no';
      this.assistance.filter(row => row.id === id)[0].value = true;
    }
  },

  methods: {
    selectAssistance(evt) {
      // Tell the root component about what just got selected/deselected
      this.$root.$emit('formEntry', {
        name: 'toileting.consent',
        value: evt.target.id.endsWith('yes') ? 'yes' : 'no',
      });
    },

    selectToileting(idx) {
      this.options[idx].selected = !this.options[idx].selected;
    },
  },
};
</script>
